import React from 'react'

export default function ProductRightArrow() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5233 9.00047L4.3942 17.1296C4.19427 17.3295 4.19427 17.6501 4.3942 17.8501C4.59413 18.05 4.91476 18.05 5.11469 17.8501L13.6059 9.35883C13.8058 9.1589 13.8058 8.83827 13.6059 8.63834L5.11469 0.150888C5.01661 0.0528107 4.88459 0 4.75633 0C4.62808 0 4.49605 0.0490379 4.39797 0.150888C4.19804 0.350815 4.19804 0.671452 4.39797 0.871378L12.5233 9.00047Z" fill="#A89F9F" fillOpacity="0.7" />
    </svg>
  )
}
